import React, { type FC, type ReactNode } from 'react';

interface CardShellProps {
  children: ReactNode;
  /**
   * Carousel mode: outer wrapper has no background so the inner items
   * (which carry their own tinted surfaces) become the visible cards.
   */
  wide?: boolean;
  className?: string;
}

/**
 * The tool-card surface.
 *
 * `ShimmerCard` renders *through* this component rather than copying its
 * numbers. It used to duplicate them and drift: the skeleton was 480px wide
 * with radius 16, a `--gem-outline-variant` border and a `--menu-bg` fill,
 * while the real card was 520px, radius 24, borderless and tinted. Every tool
 * call therefore snapped 40px wider and 8px rounder at the exact moment its
 * result arrived — the most visible frame in the whole interaction.
 *
 * Keep them sharing this element. A skeleton's only job is to occupy the box
 * its result is about to fill.
 */
export const CardShell: FC<CardShellProps> = ({ children, wide, className }) => {
  return (
    <div
      className={`tabbio-card-shell overflow-hidden ${className ?? ''}`}
      style={{
        borderRadius: wide ? 0 : 'var(--chat-card-radius)',
        background: wide ? 'transparent' : 'var(--tabbio-surface-container)',
        maxWidth: wide ? undefined : 'var(--chat-card-max-width)',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
};
